import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { BaseApi } from '@/api/base-api';
import type {
  PaginatedProvidersEnabledRuleResponse,
  ProvidersEnabledRuleCreate,
  ProvidersEnabledRuleResponse,
  ProvidersEnabledRuleUpdate,
  ProvidersEnabledRuleSortBy,
  ProvidersEnabledRuleState,
} from '@/open-api/models';

type GetListQuery = {
  aggregatorId?: string;
  providerId?: string;
  state?: ProvidersEnabledRuleState;
  page?: number;
  perPage?: number;
  sortDirection?: 'asc' | 'desc';
  sortBy?: ProvidersEnabledRuleSortBy;
};

export class ProvidersEnabledRulesApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/common/catalog';

  public getList(
    query: GetListQuery,
  ): Promise<PaginatedProvidersEnabledRuleResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/providers-enabled-rules?${this.queryToQueryString(query)}`,
      {},
    );
  }

  public create(dto: ProvidersEnabledRuleCreate): Promise<ProvidersEnabledRuleResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      '[POST] /api/v1/providers-enabled-rules',
      dto,
    );
  }

  public update(
    id: string,
    dto: ProvidersEnabledRuleUpdate,
  ): Promise<ProvidersEnabledRuleResponse> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PATCH] /api/v1/providers-enabled-rules/${id}`,
      dto,
    );
  }

  public delete(id: string): Promise<void> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[DELETE] /api/v1/providers-enabled-rules/${id}`,
      {},
    );
  }
}
